import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { PackingForm } from '../../../app/models/PackingForm';
import PackingForm_Form from './forms/PackingForm_Form';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    packingForm: PackingForm;
    setPackingForm: (packingForm: PackingForm) => void;
    errorFields?: any;
}

const UnitFormContainer = ({
    fetching,
    action,
    cancel,
    packingForm,
    setPackingForm,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <PackingForm_Form
                        packingFormDataForm={packingForm}
                        setPackingFormDataForm={setPackingForm}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default UnitFormContainer;
